import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

interface Props {
  date: Date,
  onSelectedDateChange: (date: Date | null) => void,
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    datePicker: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
  }),
);

export default ((props) => {

  const classes = useStyles();

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        className={classes.datePicker}
        label="Recorded Date"
        format="yyyy/MM/dd"
        value={props.date}
        onChange={props.onSelectedDateChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
      />
    </MuiPickersUtilsProvider>
  );
}) as React.FC<Props>;
